import React, { Component } from 'react';
import './UserInfo.scss';
import CheckboxField from '../../../helpers/Fields/CheckboxField';
import PropTypes from 'prop-types'
import { getUserCountQuestion } from '../../../AdminPanel/Users/actions';
import Spiner from '../../../helpers/Spiner/Spiner';
import { connect } from 'react-redux'
import { MODAL_FORM_TEACHER, showModal } from '../../../../modules/modals';
import classNames from 'classnames';
import SwitchField from '../../../helpers/Fields/SwitchField';
import { statusTeacher } from '../../actions';

class UserInfo extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  state = {
    white: 0,
    red: 0,
    green: 0,
    total: 0,
    spiner: true
  }

  async componentDidMount(){
    const {teacher} = this.props;
    const res = await getUserCountQuestion({user_id: teacher.id});
    const counts = {
      total: 0,
    };

    res.forEach(item => {
      if(item.status == 2){
        counts.white = item.count;
        counts.total += parseInt(item.count)
      }

      if(item.status == 3){
        counts.red = item.count;
        counts.total += parseInt(item.count)

      }

      if(item.status == 1){
        counts.green = item.count;
        counts.total += parseInt(item.count)

      }

    })


    this.setState({...counts, spiner: false});

  }

  onChange = async (value) => {
    const {teacher} = this.props;
    try {
      this.setState({spiner: true})
      const result = await this.props.statusTeacher({id: teacher.id, status: value});
      this.setState({spiner: false})
    } catch (error) {
      this.setState({spiner: false})
    }
  }
  render() {
    const {teacher, showModal} = this.props;
    const {formatMessage} = this.context;
    const {white, green, red, total, spiner} = this.state;
 
    return (
      <div className="UserInfo">
        {spiner && <div className="spinner-block">
          <Spiner />
        </div>}
        <div className="row" style={{maxWidth: '100%'}}>
          <div className="col-md-4">
            <label style={{marginBottom: 10, cursor: 'default', fontSize: 18, color: '#a8a8a8'}}>{formatMessage('txtQuestionBank')}:</label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.allow_delete_question
              }}
              label={formatMessage('txtCaptionTeacherAllowDeleteQuestion')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.allow_delete_question == 1,
                'fa-times-circle': teacher.permission.allow_delete_question == 0,
              })} />
              {formatMessage('txtCaptionTeacherAllowDeleteQuestion')}
            </label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.allow_empty_trash
              }}
              label={formatMessage('txtCaptionTeacherAllowEmptyTrash')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.allow_empty_trash  == 1,
                'fa-times-circle': teacher.permission.allow_empty_trash == 0,
              })} />
              {formatMessage('txtCaptionTeacherAllowEmptyTrash')}
            </label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.add_new_question
              }}
              label={formatMessage('txtCaptionTeacherAddNewQuestion')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.add_new_question  == 1,
                'fa-times-circle': teacher.permission.add_new_question== 0,
              })} />
              {formatMessage('txtCaptionTeacherAddNewQuestion')}
            </label>
          </div>
          <div className="col-md-4">
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.classrooms
              }}
              label={formatMessage('txtCaptionTeacherClassRooms')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.classrooms  == 1,
                'fa-times-circle': teacher.permission.classrooms== 0,
              })} />
              {formatMessage('txtCaptionTeacherClassRooms')}
            </label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.quizzes
              }}
              label={formatMessage('txtCaptionTeacherQuizzes')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.quizzes  == 1,
                'fa-times-circle': teacher.permission.quizzes== 0,
              })} />
              {formatMessage('txtCaptionTeacherQuizzes')}
            </label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.statistics
              }}
              label={formatMessage('txtCaptionTeacherStatistics')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.statistics  == 1,
                'fa-times-circle': teacher.permission.statistics== 0,
              })} />
              {formatMessage('txtCaptionTeacherStatistics')}
            </label>
            {/* <CheckboxField
              type="int"
              input={{
                value: teacher.permission.lecture_hall
              }}
              label={formatMessage('txtCaptionTeacherLectureHall')}
            /> */}
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.lecture_hall  == 1,
                'fa-times-circle': teacher.permission.lecture_hall== 0,
              })} />
              {formatMessage('txtCaptionTeacherLectureHall')}
            </label>
            <label className="check-perm">
              <i className={classNames("far", {
                'fa-check-circle': teacher.permission.flash_card  == 1,
                'fa-times-circle': teacher.permission.flash_card== 0,
              })} />
              {formatMessage('txtCaptionTeacherFlashCard')}
            </label>
          </div>
          <div className="col-md-2">
            <div className="count-questions">
              <div className="item white">{white}</div>
              <div className="item red">{red}</div>
              <div className="item green">{green}</div>
              <div className="item blue">{total}</div>
            </div>
            <SwitchField
              label={formatMessage('txtTeacherStatus')}
              input={{
                value: teacher.status == 10,
                onChange: this.onChange
              }}
              meta={{}}
            />
          </div>
          <div className="col-md-2 actions">
            <button className="btn btn-info btn-sm" onClick={() => {
              showModal({
                modalType : MODAL_FORM_TEACHER,
                modalProps : {
                  initialValues: teacher,
                  typeForm: 'update'
                }
              });
            }}>{formatMessage('txtEditTeacher')}</button>
            <button className="btn btn-warning btn-sm" onClick={() => {
              showModal({
                modalType : MODAL_FORM_TEACHER,
                modalProps : {
                  initialValues: teacher,
                  typeForm: 'reset-password'
                }
              });
            }}>{formatMessage('txtResetPassword')}</button>
          </div>
        </div>
       
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal,
  statusTeacher
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/DataUsers/UserInfo.jsx